import { Nullable } from "@maven-rest/common/common.types";
import { createContext, useContext, useState } from "react";
import { StudySpecExcludeTriggers } from "maven-lib/dist/consts/edc";

interface CrfSpecContextProps {
  crfSpec: Nullable<StudySpecExcludeTriggers>;
  setCrfSpec: (crfSpec: Nullable<StudySpecExcludeTriggers>) => void;
}

interface CrfSpecContextProviderProps {
  crfSpec: Nullable<StudySpecExcludeTriggers>;
  children: React.ReactNode;
}

const CrfSpecContext = createContext<CrfSpecContextProps>({
  crfSpec: null,
  setCrfSpec: () => {},
});

export function CrfSpecContextProvider(props: CrfSpecContextProviderProps) {
  const [crfSpec, setCrfSpecState] = useState<Nullable<StudySpecExcludeTriggers>>(props.crfSpec);

  const setCrfSpec = (crfSpec: Nullable<StudySpecExcludeTriggers>) => {
    setCrfSpecState(crfSpec);
  };

  return <CrfSpecContext.Provider value={{ crfSpec, setCrfSpec }}>{props.children}</CrfSpecContext.Provider>;
}

export function useCrfSpecContext() {
  return useContext(CrfSpecContext);
}
